import { cn } from "@/lib/utils"

/**
 * A thin vertical rule between groups of controls in a toolbar.
 *
 * Toolbars here are rows of same-sized round buttons, and past a handful of them nothing in the
 * row says which belong together. The rule does, without adding anything else to look at.
 */
export function ToolbarDivider({ className }: { className?: string }) {
  return <div aria-hidden className={cn("h-5 w-px shrink-0 bg-border", className)} />
}
